// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
import "bootstrap/dist/js/bootstrap";
import {
  Carousel,
  CarouselItem,
  Icon,
  Menu,
  MenuItem,
  MenuItemGroup,
  Option,
  Pagination,
  Select,
  Submenu
} from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "lib-flexible/flexible";
import Vue from "vue";
import VueAMap from "vue-amap";
import "../src/assets/font/iconfont.js";
import http from "../static/http.js";
import wxHttp from "../static/wxHttp.js";
import App from "./App";
import "./permission"; // permission control
import router from "./router";
Vue.use(VueAMap)
  .use(Pagination)
  .use(Menu)
  .use(Submenu)
  .use(MenuItem)
  .use(MenuItemGroup)
  .use(Select)
  .use(Option)
  .use(Carousel)
  .use(CarouselItem)
  .use(Icon);

VueAMap.initAMapApiLoader({
  key: "your amap key",
  plugin: [
    "AMap.Autocomplete",
    "AMap.PlaceSearch",
    "AMap.Scale",
    "AMap.OverView",
    "AMap.ToolBar",
    "AMap.MapType",
    "AMap.PolyEditor",
    "AMap.CircleEditor"
  ],
  v: "1.4.4"
});

Vue.config.productionTip = false;
Vue.config.ignoredElements = ["wx-open-launch-weapp"];
// 判断浏览器
let isPC = function(ua) {
  var Agents = new Array(
    "android",
    "iphone",
    "symbianOS",
    "windows phone",
    "ipad",
    "ipod"
  );
  let flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (ua.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
};
Vue.prototype.$http = http;
Vue.prototype.$wxHttp = wxHttp;
Vue.prototype.$browser = () => {
  let mobile = {
    IPHONE: /IPHONE/gi,
    HUAWEI: /huawei/gi,
    XIAOMI: /mi/gi,
    VIVO: /vivo/gi,
    OPPO: /OPPO/gi,
    SAMSUNG: /samsung/gi,
    SONY: /SONY/gi,
    NOKIA: /Nokia/gi,
    HTC: /HTC/gi,
    ZTE: /ZTE/gi,
    LENOVO: /Lenovo/gi,
    ZUK: /ZUK/gi,
    ONEPLUS: /ONEPLUS/gi,
    MEIZU: /flyme/gi,
    HONOR: /Honor|HONOR/gi
  };

  const ua = navigator.userAgent.toLowerCase(); //获取浏览器标识并转换为小写
  // console.log(ua, "ua");
  const curConfig = {
    isIOS: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //是否苹果
    isAndroid: ua.indexOf("android") > -1 || ua.indexOf("adr") > -1, //是否安卓
    isPC: isPC(ua), //是否PC
    isHarmonyOS: /openharmony/i.test(ua), // 是否纯血鸿蒙系统
    isWeiXin: ua.match(/MicroMessenger/i) == "micromessenger", //是否微信
    isQQ: ua.indexOf(" qq/") > -1, //是否QQ
    isApp: ua.indexOf("isApp") > -1, //是否某个应用
    isBaidu: ua.indexOf("baidubrowser") > -1, //百度浏览器
    isSougou: ua.indexOf("metasr") > -1, // 搜狗
    isQQbrowse: ua.indexOf("qqbrowse") > -1, //QQ浏览器
    isUC: ua.indexOf("ubrowser") > -1, //UC浏览器,
    isHUAWEI: mobile["HUAWEI"].test(ua), //华为浏览器,
    isXIAOMI: mobile["XIAOMI"].test(ua), //小米浏览器
    isVIVO: mobile["VIVO"].test(ua), //VIVO浏览器
    isOPPO: mobile["OPPO"].test(ua), // OPPO浏览器
    isSAMSUNG: mobile["SAMSUNG"].test(ua), //三星浏览器
    isHTC: mobile["HTC"].test(ua), // HTC浏览器
    isZTE: mobile["ZTE"].test(ua), //中兴浏览器
    isLENOVO: mobile["LENOVO"].test(ua), // 联想浏览器，
    isZUK: mobile["ZUK"].test(ua),
    isONEPLUS: mobile["ONEPLUS"].test(ua), // 一加浏览器
    isMEIZU: mobile["MEIZU"].test(ua),
    isHONOR: mobile["HONOR"].test(ua),
    isWXwork:
      ua.indexOf("wxwork") > -1 &&
      ua.match(/MicroMessenger/i) == "micromessenger"
  };
  return curConfig;
};
try {
  let $czc = _czc || [];
  $czc.push(["_setAccount", "1278811362"]);
  Vue.prototype.$czc = $czc;
} catch (e) {}
try {
  var $hmt = _hmt || [];
  $hmt.push(["_setAccount", "26588eaa9e35c35d48f861e808a46521"]);
  Vue.prototype.$hmt = $hmt;
} catch (e) {}

new Vue({
  el: "#app",
  router,
  components: {
    App
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js